export default {"src":"/_next/static/media/nhs.e0274fee.svg","height":43,"width":190,"blurWidth":0,"blurHeight":0};